import { render } from "./EditNoteDetails.vue?vue&type=template&id=33d56fca&scoped=true"
import script from "./EditNoteDetails.vue?vue&type=script&lang=js"
export * from "./EditNoteDetails.vue?vue&type=script&lang=js"

import "./EditNoteDetails.vue?vue&type=style&index=0&id=33d56fca&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d56fca"]])

export default __exports__